export class IterableDict {
    entries;
    constructor(entries) {
        this.entries = entries;
    }
    map(callback) {
        const entries = this.entries.map(([key, value]) => {
            const newValue = callback(value, key);
            return [key, newValue];
        });
        return new IterableDict(entries);
    }
    mapKeys(callback) {
        const entries = this.entries.map(([key, value]) => {
            const newKey = callback(key, value);
            return [newKey, value];
        });
        return new IterableDict(entries);
    }
    filter(callback) {
        const entries = this.entries.filter(([key, value]) => callback(value, key));
        return new IterableDict(entries);
    }
    toObject() {
        const result = {};
        for (const [key, value] of this.entries) {
            result[key] = value;
        }
        return result;
    }
}
